import { z } from 'zod';

export const BillingCycleSchema = z.object({
  interval: z.enum(['day', 'week', 'month', 'year']),
  frequency: z.number(),
});

export type BillingCycleType = z.infer<typeof BillingCycleSchema>;
